(() => {
  const root = document.querySelector('[data-sn2-featured]');
  if (!root) return;

  const cards = Array.from(root.querySelectorAll('[data-sn2-review-card]'));
  const dots = Array.from(root.querySelectorAll('[data-sn2-review-dot]'));
  const previous = root.querySelector('[data-sn2-review-prev]');
  const next = root.querySelector('[data-sn2-review-next]');
  let activeIndex = 0;

  function show(index) {
    activeIndex = (index + cards.length) % cards.length;
    cards.forEach((card, cardIndex) => {
      const isActive = cardIndex === activeIndex;
      card.classList.toggle('is-active', isActive);
      card.hidden = !isActive;
      card.setAttribute('aria-hidden', String(!isActive));
    });
    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === activeIndex;
      dot.classList.toggle('is-active', isActive);
      if (isActive) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  previous?.addEventListener('click', () => show(activeIndex - 1));
  next?.addEventListener('click', () => show(activeIndex + 1));
  dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
  show(0);

  const polishReviewSummary = () => {
    const summary = document.querySelector('#customer-reviews .sn-loox-summary');
    if (!summary) return false;
    const title = summary.querySelector('strong');
    if (title) title.textContent = 'What customers say';
    const sourceLabel = summary.querySelector('.sn-loox-ai > span:last-child');
    if (sourceLabel) sourceLabel.textContent = 'Based on our top customer reviews';
    return true;
  };

  if (!polishReviewSummary()) {
    const observer = new MutationObserver(() => {
      if (polishReviewSummary()) observer.disconnect();
    });
    const reviews = document.querySelector('#customer-reviews');
    if (reviews) observer.observe(reviews, { childList: true, subtree: true });
  }

  const reviews = document.querySelector('#customer-reviews');

  const balanceReviewColumns = () => {
    if (!reviews || !window.matchMedia('(max-width:760px)').matches) return;
    const grid = reviews.querySelector('.sn-loox-grid');
    const columns = grid ? Array.from(grid.querySelectorAll(':scope > .sn-loox-col')) : [];
    if (columns.length < 2) return;

    let cards = Array.from(grid.querySelectorAll('.sn-loox-card'));
    if (!cards.length) return;

    if (cards.some((card) => !card.dataset.sn2ReviewOrder)) {
      const sourceColumns = columns.map((column) => Array.from(column.children));
      cards = [];
      const longestColumn = Math.max(...sourceColumns.map((column) => column.length));
      for (let row = 0; row < longestColumn; row += 1) {
        sourceColumns.forEach((column) => {
          if (column[row]) cards.push(column[row]);
        });
      }
      cards.forEach((card, index) => {
        card.dataset.sn2ReviewOrder = String(index);
      });
    } else {
      cards.sort((a, b) => Number(a.dataset.sn2ReviewOrder) - Number(b.dataset.sn2ReviewOrder));
    }

    columns.forEach((column) => column.replaceChildren());
    cards.forEach((card) => {
      const shortest = columns.reduce((current, column) =>
        column.scrollHeight < current.scrollHeight ? column : current
      );
      shortest.append(card);
    });
  };

  const balanceReviewsBeforeTheyAreVisible = () => {
    if (!reviews || !window.matchMedia('(max-width:760px)').matches) return;
    const grid = reviews.querySelector('.sn-loox-grid');
    if (!grid) return;

    const images = Array.from(grid.querySelectorAll('.sn-loox-card > img'));
    images.forEach((image) => {
      image.loading = 'eager';
    });

    const settled = images.map((image) => {
      if (image.complete) return Promise.resolve();
      return new Promise((resolve) => {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', resolve, { once: true });
      });
    });

    Promise.all(settled).then(() => {
      requestAnimationFrame(() => {
        if (reviews.getBoundingClientRect().top > window.innerHeight) {
          balanceReviewColumns();
        }
      });
    });
  };

  requestAnimationFrame(balanceReviewsBeforeTheyAreVisible);
})();

(() => {
  const repeatButton = document.querySelector('[data-sn-repeat-cta]');
  if (!repeatButton) return;

  repeatButton.addEventListener('click', async () => {
    const variantId = Number(repeatButton.dataset.id || 0);
    const quantity = Math.max(1, Number(repeatButton.dataset.quantity || 1));
    if (!variantId) return;

    repeatButton.disabled = true;
    repeatButton.textContent = 'Adding to cart…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      if (!response.ok) throw new Error('add to cart failed');
      window.location.href = '/checkout';
    } catch (error) {
      repeatButton.disabled = false;
      repeatButton.textContent = 'ADD TO CART';
      window.alert('Could not add this item to your cart. Please try again.');
    }
  });
})();
